import React from 'react';
import { PrismicRichText } from '@prismicio/react';
import styled from 'styled-components';
import { FIVE_STARS_IMAGE, MEDIA } from '@constants';
import LazyLoadImage from '../LazyLoadImage';
import { TEXT_STYLES, TextVariant } from './Typography';

interface TestimonialModuleItemProps {
  itemColor: string;
  item: any;
}

const TestimonialModuleItem: React.FC<TestimonialModuleItemProps> = ({ itemColor, item }) => {
  return (
    <Wrapper $itemColor={itemColor}>
      {item.image.url && (
        <ImageWrapper>
          <LazyLoadImage src={item.image.url} alt="" />
        </ImageWrapper>
      )}
      <LazyLoadImageFiveStars src={FIVE_STARS_IMAGE} alt="" />
      <Quote>
        <PrismicRichText field={item.testimonial.richText} />
      </Quote>
      <Name>{item.person_name}</Name>
    </Wrapper>
  );
};

export default TestimonialModuleItem;

const Wrapper = styled.div<{ $itemColor: string }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 24px;
  background-color: ${(props) => props.$itemColor};
  padding: 40px 24px;
  border-radius: 12px;

  ${MEDIA.laptop} {
    max-width: 350px;
    width: 75vw;
    margin-right: 16px;
    height: 100%;
    min-height: 380px;
    justify-content: center;
  }
`;

const ImageWrapper = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  overflow: hidden;
`;

const Quote = styled.div`
  > * {
    ${TEXT_STYLES[TextVariant.Heading6]};
    text-align: center;
    color: inherit;
  }
`;

const LazyLoadImageFiveStars = styled(LazyLoadImage)`
  width: 100px;
  height: 16px;
`;

const Name = styled.div`
  ${TEXT_STYLES[TextVariant.BodyBoldLG]};
`;
